import React from 'react';
import styles from './LogoCarousel.module.css';

const logos = [
  { src: '/assets/website/logo-aic.png', alt: 'AIC' },
  { src: '/assets/website/logo-aws.png', alt: 'AWS', size: 'large' },
  { src: '/assets/website/logo-bbb.png', alt: 'BBB Accredited Business', size: 'large' },
  { src: '/assets/website/logo-claimmd.png', alt: 'Claim.MD' },
  { src: '/assets/website/logo-phoenixfwd.webp', alt: 'Phoenix FWD' },
  { src: '/assets/website/logo-nlm.png', alt: 'National Library of Medicine', size: 'large' },
];

const LogoCarousel = ({ speed = 30 }) => {
  return (
    <div className={styles['logo-carousel']}>
      <div className={styles['logo-carousel__track']} style={{ '--speed': `${speed}s` }}>
        {logos.map((logo) => (
          <div key={logo.alt} className={`${styles['logo-carousel__item']} ${logo.size === 'large' ? styles['logo-carousel__item--large'] : ''}`}>
            <img src={logo.src} alt={logo.alt} loading="lazy" />
          </div>
        ))}
        {logos.map((logo) => (
          <div key={`dup-${logo.alt}`} className={`${styles['logo-carousel__item']} ${logo.size === 'large' ? styles['logo-carousel__item--large'] : ''}`}>
            <img src={logo.src} alt={logo.alt} loading="lazy" />
          </div>
        ))}
      </div>
      <div className={`${styles['logo-carousel__fade']} ${styles['logo-carousel__fade--left']}`}></div>
      <div className={`${styles['logo-carousel__fade']} ${styles['logo-carousel__fade--right']}`}></div>
    </div>
  );
};

export default LogoCarousel;
